module.exports = __webpack_public_path__ + "static/img_4636-e82aad81e3ff1dbc06c1b2941ed5c512.webp";